/**
 *  RightCollapse 小组件
 *
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2023, all rights reserved. Essa.cn
 */
import React, { useState, } from 'react';
/** Use Authorized check all menu item */
const RightCollapse = ({changeBack=""}) => {
    const [rightCollapse,setRightCollapse] = useState(false);
    return ( <span className={"rightCollapse"} onClick={()=>{
        setRightCollapse(!rightCollapse)
        if(changeBack)changeBack(!rightCollapse)
    }}>
            {rightCollapse?<i className="ri-indent-decrease font-16" />:<i className="ri-indent-increase font-16" />}
    </span>);
};

export default RightCollapse;